import { useQuery } from "@tanstack/react-query";

import { airLuggageJourneysApi } from "api";
import { transformToAirLuggageJourneyClass } from "models/journeys/AirLuggageJourney";

const fetchAirLuggageForJourney = async (journeyId: number) => {
  const [error, response] = await airLuggageJourneysApi.fetchAirLuggageForJourneys(journeyId);

  if (error) {
    throw error;
  } else {
    return response;
  }
};

const useFetchAirLuggageJourneys = (journeyId: number) => {
  return useQuery({
    queryKey: ["journey", journeyId, "airLuggages"],
    queryFn: () => fetchAirLuggageForJourney(journeyId),
    select: (data) => data.map((airLuggageJourney) => transformToAirLuggageJourneyClass(airLuggageJourney)),
  });
};

export default useFetchAirLuggageJourneys;
